import styled from 'styled-components';
import { Stack } from 'components/Stack';

export const Container = styled(Stack)`
  height: 100%;
  text-align: center;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-size: 16px;
  line-height: 24px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

export const RejectReasonContainer = styled.div`
  width: 100%;
  padding: 16px;
  position: relative;
  ::before {
    content: '';
    position: absolute;
    display: inline-block;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.configs.CTAButton.bgColor};
    opacity: 0.5;
  }
`;

export const RejectReasonText = styled.div`
  position: relative;
  z-index: 1;
  word-break: break-word;
`;
